<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn v-if="!readonly" @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
        <template v-slot:item.range="{item}">
            <div>{{ item.range.lower }}-{{ item.range.upper }}</div>
        </template>
      <template v-slot:item.strict="{item}">
        <div>{{ item.strict ? "ON" : "OFF" }}</div>
      </template>
      <template v-if="!readonly" v-slot:item.actions="{item}">
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-rarity-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RarityConfig} from "@/modules/redactor/models/rarity/RarityConfig";
import RRarityDialog from "@/modules/redactor/views/rarity/r-rarity-dialog";


export default {
  name: "r-rarity-items",
  components: {RRarityDialog},
  props: {
    title: VueTypes.string.isRequired,
    items: VueTypes.arrayOf(RarityConfig).isRequired,
    readonly: VueTypes.bool.def(false)
  },
  data: () => ({
    headers: [
      {text: 'Amount', value: 'amount'},
      {text: 'Percent', value: 'percent'},
      {text: 'Range', value: 'range'},
      {text: 'Strict', value: 'strict'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if (this.items.find(v => v.amount === data.amount)) {
              this.$alert("Duplicate amount!");
            } else {
              this.items.push(data);
            }
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    }
  }
}
</script>